define('tdwallpaper', ['jquery'], function ($) {

  var tdwallpaper = {
    calculateInputs: $('.calculate').parent(),
    musterInfo: $('.js_productSample'),
    changeSelect: function changeSelect() {
      var _this = this;

      this.wallpaperSelect = jQuery('.product__select.rollproduct select');
      this.wallpaperSelectTrigger = jQuery('.product__select.wallpaper .sb-wp-inner');

      if (this.wallpaperSelect.length === 0) return;

      this.wallpaperSelectTrigger.on('click', function (e) {
        var self = jQuery(e.currentTarget);
        var selfIndex = self.data('index');
        var option = _this.wallpaperSelect.find('option:not([value=""])').eq(selfIndex);

        if (option.text().indexOf('Muster') !== -1 || option.text().indexOf('A4 Muster') !== -1) {
          _this.musterInfo.slideDown() && _this.calculateInputs.slideUp();
        } else {
          _this.musterInfo.slideUp() && _this.calculateInputs.slideDown();
        }

        selfIndex === 0 ? jQuery('#radioBtn-1').prop('checked', false) : jQuery('#radioBtn-0').prop('checked', false);

        _this.wallpaperSelectTrigger.removeClass('checked') && self.addClass('checked') && option.prop('selected', true) && _this.wallpaperSelect.trigger('change') && _this.wallpaperSelect.get(0).simulate('change');
      });

      this.wallpaperSelectTrigger.eq(0).click();
    },
    calculator: function calculator() {

      function calcStripsPerRoll(height, rollLength, repeat) {
        var retval = rollLength / (height + repeat);
        if (retval < 0) {
          return 1;
        }
        return Math.floor(retval);
      }

      function calcRollCount(width, height) {
        var rollWidth = 0.53;
        var rollLength = 10.05;
        var repeat = height * 0.1; // just adding 10% to wall height to "calculate" the pattern repeat
        return Math.ceil(width / (calcStripsPerRoll(height, rollLength, repeat) * rollWidth));
      }

      $('.product__calculator .js_calcBtn').click(function () {
        var width = parseFloat($('.product__calculator #txtWallWidth').val().replace(',', '.'));
        var height = parseFloat($('.product__calculator #txtWallHeight').val().replace(',', '.'));
        if (!width || !height) return;

        $('#amountToBasket').val(calcRollCount(width, height)) && $('#txtWallResult').find('b').html(calcRollCount(width, height)).end().show();
      });
    },
    js_amountCounter: function js_amountCounter() {
      $('body').on('click', '.js_amountCounter', function (e) {

        var inputField = $('#amountToBasket');
        var inputVal = inputField.val();
        var direction = $(e.currentTarget).attr('data-amountcounter');

        if (direction === "0") {
          if (inputVal != 1) {
            inputField.val(parseInt(inputVal) - 1);
          }
        } else {
          inputField.val(parseInt(inputVal) + 1);
        }
      });
    },
    init: function init() {
      this.changeSelect();
      this.calculator();
      this.js_amountCounter();
    }
  };

  return tdwallpaper;
});

